import delay from 'delay';

// Минимальный интервал между стартом загрузки и показом её результата: на
// быстром ответе или попадании в кэш индикатор загрузки иначе мигает, а
// интерфейс дёргается.
export const LOAD_MIN_MS = 350;

// Ждёт запрос, но не отдаёт его результат раньше, чем через LOAD_MIN_MS от
// старта. Ошибку пробрасывает сразу, не дожидаясь задержки.
export default async function withMinDelay(promise) {
  const [result] = await Promise.all([promise, delay(LOAD_MIN_MS)]);

  return result;
}
